<script setup>
import { computed } from 'vue';
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(() => `${props.row.original.type}_reports_show`);
</script>

<template>
  <div class="flex items-center gap-2">
    <span
      v-if="row.original.color"
      class="w-3 h-3 rounded-full flex-shrink-0 border border-n-weak"
      :style="{ backgroundColor: row.original.color }"
    />
    <router-link
      :to="{ name: routeName, params: { id: row.original.id } }"
      class="text-n-slate-12 hover:underline font-medium"
    >
      {{ row.original.name }}
    </router-link>
    <span
      v-if="row.original.groupName"
      class="text-xs px-2 py-0.5 rounded bg-n-alpha-2 text-n-slate-11 font-normal"
    >
      {{ row.original.groupName }}
    </span>
  </div>
</template>
